import { useMutation, useQueryClient } from "@tanstack/react-query";
import { USER_INFO_QUERY_KEY } from "Auth/Api/Queries/useUserInfoQuery";
import { JWT_KEY } from "Auth/Models/AuthConstants";
import { postApiAuthSignIn } from "Infrastructure/Api/Api";
import { HttpStatusCode } from "Infrastructure/Models/HttpStatusCodes";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export function useSignInMutation() {
	const queryClient = useQueryClient();
	const showSnackbar = useSnackbar();
	const { t } = useResource();

	const mutation = useMutation({
		mutationFn: postApiAuthSignIn,
		onSuccess: (data) => {
			// Invalidate and refetch
			if (data.status === HttpStatusCode.Ok) {
				localStorage.setItem(JWT_KEY, `Bearer ${data.data.userInfo.token}`);
				location.reload();
			} else if (data.status === HttpStatusCode.BadRequest) {
				showSnackbar(
					"Nepovedlo se přihlásit. Zkontrolujte login a heslo.",
					"warning"
				);
			} else {
				showSnackbar(t(Resources.Errors.Error500), "error");
			}

			queryClient.invalidateQueries({ queryKey: [USER_INFO_QUERY_KEY] });
		},
	});

	return mutation;
}
